import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import InsuranceBanner from '../../components/InsuranceBanner/InsuranceBanner';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo-2.svg';

const PrivacyPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <InsuranceBanner />
            <PageTitle pageTitle={'Privacy Policy'} pagesub={'Privacy'} />
            <div className="section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div style={{
                                padding: '40px',
                                background: '#fff',
                                borderRadius: '15px',
                                boxShadow: '0 5px 20px rgba(0,0,0,0.08)'
                            }}>
                                <h2 style={{fontSize: '36px', marginBottom: '30px', color: '#2c3e50'}}>Privacy Policy</h2>
                                
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    <strong>Last Updated: January 2025</strong>
                                </p>

                                <h3 style={{fontSize: '24px', marginTop: '30px', marginBottom: '15px', color: '#333'}}>Information We Collect</h3>
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    We collect information you provide directly to us, such as when you fill out a contact form, 
                                    schedule a consultation, or communicate with us via email or phone.
                                </p>

                                <h3 style={{fontSize: '24px', marginTop: '30px', marginBottom: '15px', color: '#333'}}>How We Use Your Information</h3>
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    We use the information we collect to provide, maintain, and improve our services, 
                                    communicate with you about consultations and treatments, and comply with legal obligations.
                                </p>

                                <h3 style={{fontSize: '24px', marginTop: '30px', marginBottom: '15px', color: '#333'}}>Medical Information Protection</h3>
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    All medical information is handled in accordance with HIPAA regulations. We maintain strict 
                                    confidentiality and security measures to protect your health information.
                                </p>

                                <h3 style={{fontSize: '24px', marginTop: '30px', marginBottom: '15px', color: '#333'}}>Contact Information</h3>
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    If you have any questions about this Privacy Policy, please contact us at:<br/>
                                    Email: info@ampedtherapeutics.com
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    );
};

export default PrivacyPage;